import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert, Modal, Table } from 'react-bootstrap';
import { Link, useLocation, useHistory } from 'react-router-dom';
import ReactLoading from 'react-loading';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from "../../../constants/Endpoints"
import { OpportunitiesService } from '../../../service/contacts-service'

const Criteri = () => {
    const form = useRef(null);
    const location = useLocation();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [loadingOptions, setLoadingOptions] = useState(true);
    const [options, setOptions] = useState(null);
    const [error, setError] = useState(null);
    const [prestiti, setPrestiti] = useState([]);
    const [successResult, setSuccessResult] = useState(null);
    const [criteriaSaved, setCriteriaSaved] = useState(false);
    const [savedCriteriId, setSavedCriteriId] = useState(null);
    const [opportunityId, setOpportunityId] = useState(null);
    const [contactId, setContactId] = useState(null);
    const [contactData, setContactData] = useState(null);
    const [isContactFromUrl, setIsContactFromUrl] = useState(false);
    const [products, setProducts] = useState([]);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [showResultModal, setShowResultModal] = useState(false);
    const [showRejections, setShowRejections] = useState(false);
    
    // Get first day of next month
    const getFirstDayNextMonth = () => {
        const today = new Date();
        const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        return nextMonth.toISOString().split('T')[0];
    };
    
    const [inputs, setInputs] = useState({
        quinto_cedibile: '',
        durata: '120',
        codice_fiscale: '',
        chiave_pensioni: '',
        cittadinanza: 'ITA',
        residente_in_it: '',
        sesso: 'M',
        data_di_nascita: '',
        data_di_assunzione: '',
        data_decorrenza: getFirstDayNextMonth(),
        is_part_time: '',
        part_time_percentage: '',
        codice_fiscale_datore: '',
        retribuzione: '',
        mensilita: '13',
        tfr: '',
        tfr_data_rif: '',
        is_tempo_indeterminato: '',
        malattia: '',
        cig_oltre_40_ore: '',
        edile: ''
    });

    // Fetch products from backend
    const fetchProducts = async () => {
        try {
            const response = await axios({
                method: 'get',
                url: `${BASE_URL}/api-v1/product/list-complete`,
                withCredentials: true
            });
            
            if (response.data && response.data.data) {
                setProducts(response.data.data);
            }
        } catch (err) {
            console.error('Error fetching products:', err);
        }
    };

    // Load options on component mount and check URL params
    useEffect(() => {
        const initialize = async () => {
            await fetchProducts();
            await loadOptions();
            await checkUrlParams();
        };
        initialize();
    }, []);

    // Check URL params for product pre-selection and contact_id
    const checkUrlParams = async () => {
        const searchParams = new URLSearchParams(location.search);
        const productParam = searchParams.get('prodotti');
        const contactIdParam = searchParams.get('contact_id');
        const opportunityIdParam = searchParams.get('opportunity_id');
        
        if (productParam && products.length > 0) {
            // Find product by type
            const foundProduct = products.find(p => p.type === productParam);
            if (foundProduct) {
                setSelectedProductId(foundProduct.id);
            }
        }
        
        // If contact_id is provided, fetch contact data
        if (contactIdParam) {
            setContactId(contactIdParam);
            setIsContactFromUrl(true);
            await fetchContactData(contactIdParam);
        }

        if (opportunityIdParam) {
            setOpportunityId(opportunityIdParam);
             try {
                const oppService = new OpportunitiesService()
                const opp = await oppService.view(opportunityIdParam)
                if (opp && opp.product && opp.product.id) {
                    setSelectedProductId(opp.product.id)
                }
            } catch (error) {
                console.error('Error fetching opportunity:', error)
            }
        }
    };
    
    // Fetch contact data from backend
    const fetchContactData = async (contactId) => {
        try {
            const response = await axios({
                method: 'get',
                url: `${BASE_URL}/api-v1/people/contact/${contactId}/view`,
                withCredentials: true
            });
            
            if (response.data) {
                const contact = response.data;
                setContactData(contact);
                
                // Prefill form fields from contact data
                setInputs(prev => ({
                    ...prev,
                    codice_fiscale: contact.codice_fiscale || '',
                    chiave_pensioni: contact.chiave_pensione || '',
                    cittadinanza: contact.cittadinanza || 'ITA',
                    residente_in_it: contact.residente_in_it !== null && contact.residente_in_it !== undefined ? String(contact.residente_in_it) : '',
                    sesso: contact.sesso || 'M',
                    data_di_nascita: contact.data_di_nascita || '',
                    data_di_assunzione: contact.data_di_assunzione || '',
                    is_part_time: contact.is_part_time !== null && contact.is_part_time !== undefined ? String(contact.is_part_time) : '',
                    part_time_percentage: contact.part_time_percentage || '',
                    codice_fiscale_datore: contact.codice_fiscale_datore || '',
                    retribuzione: contact.retribuzione || '',
                    mensilita: contact.mensilita || '13',
                    tfr: contact.tfr || '',
                    tfr_data_rif: contact.tfr_data_riferimento || '',
                    is_tempo_indeterminato: contact.is_tempo_indeterminato !== null && contact.is_tempo_indeterminato !== undefined ? String(contact.is_tempo_indeterminato) : '',
                    malattia: contact.malattia || '',
                    cig_oltre_40_ore: contact.cig_oltre_40_ore || '',
                    quinto_cedibile: contact.quinto_cedibile || ''
                }));

                if (contact.trattenute && Array.isArray(contact.trattenute)) {
                    const mappedPrestiti = contact.trattenute.map(t => ({
                        da_estinguere: '',
                        tipo: t.tipo || '',
                        rata: t.amount ? String(Math.round(parseFloat(t.amount))) : '',
                        durata: t.duration ? String(t.duration) : '',
                        residuo: t.residuo || '',
                        decorrenza: t.start_date || ''
                    }));
                    setPrestiti(mappedPrestiti);
                }
            }
        } catch (err) {
            console.error('Error fetching contact:', err);
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: 'Errore nel recupero dei dati del contatto',
            });
        }
    };

    // Determine employment type based on selected product
    const getEmploymentType = () => {
        if (!selectedProductId) return '';
        const product = products.find(p => p.id === selectedProductId);
        if (!product) return '';

        // console.log("PRODUCT")
        // console.log(product.type.toLowerCase())
        
        const productType = product.type.toLowerCase();

        if (productType.includes('pubblico') && productType.includes('pensionato')) {
            return 'state';
        }

        if (productType.includes('pensionati')) {
            return 'pensioner';
        } else if (productType.includes('statale')) {
            return 'state';
        } else {
            return 'private';
        }
    };

    const getOptions = async () => {
        try {
            const response = await axios({
                method: 'get',
                url: "https://censimenti-csq.jazeeautomation.com/criteri_assuntivi/api/esegui",
                headers: {
                    'x-api-key': process.env.REACT_APP_CENSIMENTI_API_KEY || ''
                }
            });
            
            return {
                success: true,
                data: response.data
            };
        } catch (error) {
            console.error('Error fetching criteri options:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Errore durante il caricamento delle opzioni',
                data: null
            };
        }
    }

    const submitCriteri = async (formData) => {
        try {
            const response = await axios({
                method: 'post',
                url: "https://censimenti-csq.jazeeautomation.com/criteri_assuntivi/api/esegui",
                headers: {
                    'x-api-key': process.env.REACT_APP_CENSIMENTI_API_KEY || '',
                    'Content-Type': 'application/json'
                },
                data: formData
            });
            
            console.log('Criteri Response:', response.data);

            const errors = response.data.errors || null;
            const isSuccess = !errors || errors?.length === 0;
            console.log("debug");
            console.log(errors);
            console.log(isSuccess);
            return {
                success: isSuccess,
                data: response.data,
                errors: errors
            };
        } catch (error) {
            console.error('Error submitting criteri:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Errore durante l\'invio dei dati',
                data: null
            };
        }
    }

    const saveCriteriToBackend = async (criteriData) => {
        try {
            const response = await axios({
                method: 'post',
                url: `${BASE_URL}/api-v1/people/criteri/create`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: criteriData,
                withCredentials: true
            });
            
            console.log('Saved to backend:', response.data);
            return {
                success: true,
                data: response.data
            };
        } catch (error) {
            console.error('Error saving to backend:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Errore durante il salvataggio',
                data: null
            };
        }
    }

    const loadOptions = async () => {
        setLoadingOptions(true);
        const result = await getOptions();
        
        if (result.success) {
            setOptions(result.data);
            // Set default data_decorrenza if provided
            if (result.data.data_decorrenza) {
                setInputs(prev => ({ ...prev, data_decorrenza: result.data.data_decorrenza }));
            }
        } else {
            setError(result.error);
            console.error('Criteri load error:', result.error);

            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: 'Impossibile caricare le opzioni',
            });
        }
        setLoadingOptions(false);
    };

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;

        // Enforce 1 decimal place
        if (name === 'quinto_cedibile' || name === 'part_time_percentage' || name === 'tfr') {
        if (value.includes('.') && value.split('.')[1].length > 1) {
            return
        }
        }

        // Enforce 0 decimal places
        if (name === 'retribuzione') {
        if (value.includes('.')) {
            return
        }
        }
        
        setInputs(values => ({ ...values, [name]: value }));
    };

    const handlePrestitoChange = (index, field, value) => {
        const newPrestiti = [...prestiti];
        newPrestiti[index] = { ...newPrestiti[index], [field]: value };

        if (field === 'residuo') {
        if (value.includes('.') && value.split('.')[1].length > 1) {
            return
        }
        }

        // Enforce 0 decimal places
        if (field === 'rata') {
        if (value.includes('.')) {
            return
        }
        }

        setPrestiti(newPrestiti);
    };

    const addPrestito = () => {
        setPrestiti([...prestiti, {
            da_estinguere: '',
            tipo: '',
            rata: '',
            durata: '',
            residuo: '',
            decorrenza: ''
        }]);
    };

    const removePrestito = (index) => {
        const newPrestiti = prestiti.filter((_, i) => i !== index);
        setPrestiti(newPrestiti);
    };

    const submitForm = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);
        
        // Get product type for the request
        const selectedProduct = products.find(p => p.id === selectedProductId);
        
        // Build the request body
        const requestData = {
            ...inputs,
            prodotto: selectedProduct ? selectedProduct.type : '',
        };
                
        // Remove tfr if its value is 0 or empty
        if (!requestData.tfr || parseFloat(requestData.tfr) === 0) {
            delete requestData.tfr;
        }

        // Add prestiti data if any
        if (prestiti.length > 0) {
            prestiti.forEach((prestito, index) => {
                const prestitoNum = index + 1;
                requestData[`prestiti${prestitoNum}_da_estinguere`] = prestito.da_estinguere || '';
                requestData[`prestiti${prestitoNum}_tipo`] = prestito.tipo || '';
                requestData[`prestiti${prestitoNum}_rata`] = prestito.rata || '';
                requestData[`prestiti${prestitoNum}_durata`] = prestito.durata || '';
                requestData[`prestiti${prestitoNum}_residuo`] = prestito.residuo || '';
                requestData[`prestiti${prestitoNum}_decorrenza`] = prestito.decorrenza || '';
            });
        }

        console.log('Submitting criteri data:', requestData);

        const result = await submitCriteri(requestData);

        console.log('Criteri submission result:', result);

        if (result.success) {
            console.log('Criteri resultsss:', result.data);
            
            // Store the result to display the button
            setSuccessResult(result.data);
            setCriteriaSaved(true);
            setShowResultModal(true);
            
            // Save to backend with both response and request
            const backendResult = await saveCriteriToBackend({
                contact: contactId, // Link to contact if available
                product: selectedProductId, // Link to product
                request: requestData,
                response: result.data
            });
            if (backendResult.success && backendResult.data?.id) {
                setSavedCriteriId(backendResult.data.id);
                console.log('Saved criteri ID:', backendResult.data.id);
            } else {
                console.warn('Failed to save to backend:', backendResult.error);
            }

            // Check for next param
            const searchParams = new URLSearchParams(location.search);
            const next = searchParams.get('next');
            if (next === 'preventivi') {
                 setTimeout(() => {
                     const params = new URLSearchParams({
                        contact_id: contactId,
                        product_id: selectedProductId,
                        opportunity_id: opportunityId || ''
                    });
                     history.push(`/preventivi?${params.toString()}`);
                 }, 1500);
            }
        } else {
            setError(result.errors[0]);
            console.error('Criteri submission error:', result.errors);
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: result.errors[0],
            });
        }
        
        setLoading(false);
    };

    const selectedProduct = products.find(p => p.id === selectedProductId);
    const productType = selectedProduct ? selectedProduct.type.toLowerCase() : '';
    const isPublicEmployee = productType.includes('pubblico') && productType.includes('dipendente');
    const isStateEmployee = productType.includes('statale') && productType.includes('dipendente');
    const isPublicPensioner = productType.includes('pubblico') && productType.includes('pensionato');

    return (
        <>
            <Container fluid className='smooth-transition'>
                <Row>
                    <Col lg="12">
                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-4">
                            <div>
                                <h4 className="mb-3">Criteri Assuntivi</h4>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb p-0 mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Dashboard</Link>
                                        </li>
                                        {contactId && (
                                            <li className="breadcrumb-item">
                                                <Link to={`/contact-view/${contactId}`}>
                                                    {contactData ? `${contactData.name} ${contactData.surname}` : 'Contatto'}
                                                </Link>
                                            </li>
                                        )}
                                        <li className="breadcrumb-item active" aria-current="page">Criteri Assuntivi</li>
                                    </ol>
                                </nav>
                            </div>
                            <Button variant="primary" className="btn-sm d-flex align-items-center" onClick={() => history.goBack()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                </svg>
                                <span className="ml-2">Indietro</span>
                            </Button>
                        </div>
                    </Col>

                    {isContactFromUrl && contactData && (
                        <Col lg="12" className="mb-3">
                            <Alert variant="info">
                                <i className="fas fa-info-circle me-2"></i>
                                Dati precompilati dal contatto: <strong>{contactData.name} {contactData.surname}</strong>
                            </Alert>
                        </Col>
                    )}

                    {error && (
                        <Col lg="12" className="mb-3">
                            <Alert variant="danger">{error}</Alert>
                        </Col>
                    )}

                    {loadingOptions ? (
                        <Col lg="12">
                            <Card>
                                <Card.Body className="text-center py-5">
                                    <ReactLoading
                                        className="mx-auto"
                                        type={"spin"}
                                        color={"#007bff"}
                                        height={50}
                                        width={50}
                                    />
                                    <p className="mt-3">Caricamento opzioni...</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    ) : (
                        <Col lg="12">
                            <Card>
                                <Card.Body className="smooth-transition">
                                    <Form className="g-3" onSubmit={submitForm} ref={form}>
                                        <div className='row'>
                                            {/* Prodotto */}
                                            <div className="col-md-6 mb-3">
                                                <Form.Label htmlFor='prodotto' className="form-label font-weight-bold text-muted text-uppercase">
                                                    Prodotti <span className="text-danger">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name='prodotto'
                                                    value={selectedProductId || ''}
                                                    onChange={(e) => setSelectedProductId(e.target.value ? parseInt(e.target.value) : null)}
                                                    required
                                                >
                                                    <option value="">Seleziona prodotto</option>
                                                    {products.map((product) => (
                                                        <option key={product.id} value={product.id}>{product.type}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text className="text-muted">
                                                    Può essere preselezionato tramite parametro URL 'prodotti'
                                                </Form.Text>
                                            </div>
                                        </div>

                                        {/* Show other fields only when product is selected */}
                                                                                {/* Line 416 omitted */}
                                        {selectedProductId && (
                                            <>
                                                <div className='row'>
                                                    {/* Codice Fiscale */}
                                                    <div className={`${getEmploymentType() === 'state' ? 'col-md-12 mb-3' : 'col-md-6 mb-3'}`}>
                                                        <Form.Label htmlFor='codice_fiscale' className="form-label font-weight-bold text-muted text-uppercase">
                                                            Codice Fiscale <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control 
                                                            type='text' 
                                                            className="form-control" 
                                                            name='codice_fiscale' 
                                                            placeholder=''
                                                            maxLength="16"
                                                            value={inputs["codice_fiscale"]}
                                                            onChange={handleChange}
                                                        />
                                                    </div>


                                                    {/* Partita Iva (Datore) - Only for private employees */}
                                                    {getEmploymentType() === 'private' && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='codice_fiscale_datore' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Partita Iva (Datore)
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type='text' 
                                                                className="form-control" 
                                                                name='codice_fiscale_datore' 
                                                                placeholder=''
                                                                maxLength="16"
                                                                value={inputs["codice_fiscale_datore"]}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    )}

                                                    {/* Chiave Pensione - Only for pensioners */}
                                                    {(getEmploymentType() === 'pensioner' || isPublicPensioner) && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='chiave_pensioni' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Chiave Pensione (Solo per i pensionati) {!inputs.quinto_cedibile && <span className="text-danger">*</span>}
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type='text' 
                                                                className="form-control" 
                                                                name='chiave_pensioni' 
                                                                placeholder=''
                                                                value={inputs["chiave_pensioni"]}
                                                                onChange={handleChange}
                                                                required={(getEmploymentType() === 'pensioner' || isPublicPensioner) && !inputs.quinto_cedibile}
                                                            />
                                                        </div>
                                                    )}

                                                    {/* Cittadinanza */}
                                                    <div className="col-md-6 mb-3">
                                                        <Form.Label htmlFor='cittadinanza' className="form-label font-weight-bold text-muted text-uppercase">
                                                            Cittadinanza <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            name='cittadinanza'
                                                            value={inputs["cittadinanza"]}
                                                            onChange={handleChange}
                                                            required
                                                        >
                                                            <option value="ITA">Italiana (ITA)</option>
                                                            <option value="ST">Straniera (ST)</option>
                                                        </Form.Control>
                                                    </div>

                                                    {/* Residente in Italia - Only for foreigners */}
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='residente_in_it' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Residente in Italia Dal (Stranieri) <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type='date' 
                                                                className="form-control" 
                                                                name='residente_in_it' 
                                                                value={inputs["residente_in_it"]}
                                                                onChange={handleChange}
                                                                required={inputs.cittadinanza === 'ST'}
                                                                disabled={inputs.cittadinanza !== 'ST'}
                                                            />
                                                        </div>

                                                    {/* Quinto Cedibile - Only for pensioners */}
                                                    {getEmploymentType() === 'state' && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='quinto_cedibile' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Quinto Massimo Cedibile {!inputs.chiave_pensioni && <span className="text-danger">*</span>}
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type='number' 
                                                                step="0.1"
                                                                onWheel={(e) => e.target.blur()}
                                                                className="form-control" 
                                                                name='quinto_cedibile' 
                                                                placeholder=''
                                                                value={inputs["quinto_cedibile"]}
                                                                onChange={handleChange}
                                                                required={getEmploymentType() === 'pensioner' && !inputs.chiave_pensioni}
                                                            />
                                                        </div>
                                                    )}

                                                    {/* Sesso */}
                                                    <div className="col-md-6 mb-3">
                                                        <Form.Label htmlFor='sesso' className="form-label font-weight-bold text-muted text-uppercase">
                                                            Sesso <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            name='sesso'
                                                            value={inputs["sesso"]}
                                                            onChange={handleChange}
                                                            required
                                                        >
                                                            <option value="M">Maschio</option>
                                                            <option value="F">Femmina</option>
                                                        </Form.Control>
                                                    </div>

                                                    {/* Data di Nascita */}
                                                    <div className="col-md-6 mb-3">
                                                        <Form.Label htmlFor='data_di_nascita' className="form-label font-weight-bold text-muted text-uppercase">
                                                            Data di Nascita <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control 
                                                            type='date' 
                                                            className="form-control" 
                                                            name='data_di_nascita' 
                                                            value={inputs["data_di_nascita"]}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>

                                                    {/* Data di Assunzione */}
                                                    <div className="col-md-6 mb-3">
                                                        <Form.Label htmlFor='data_di_assunzione' className="form-label font-weight-bold text-muted text-uppercase">
                                                            {isPublicPensioner ? "Data di Pensionamento" : "Data di Assunzione"} <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control 
                                                            type='date' 
                                                            className="form-control" 
                                                            name='data_di_assunzione' 
                                                            value={inputs["data_di_assunzione"]}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                    </div>

                                                    {/* Data Decorrenza */}
                                                    <div className="col-md-6 mb-3">
                                                        <Form.Label htmlFor='data_decorrenza' className="form-label font-weight-bold text-muted text-uppercase">
                                                            Data di Decorrenza <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control 
                                                            type='date' 
                                                            className="form-control" 
                                                            name='data_decorrenza' 
                                                            value={inputs["data_decorrenza"]}
                                                            onChange={handleChange}
                                                            required
                                                        />
                                                        <Form.Text className="text-muted">
                                                            Default: 1° del mese prossimo
                                                        </Form.Text>
                                                    </div>

                                                    {/* Part Time - Only for private employees */}
                                                    {(getEmploymentType() === 'private' || isStateEmployee) && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='is_part_time' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Part Time <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name='is_part_time'
                                                                value={inputs["is_part_time"]}
                                                                onChange={handleChange}
                                                                required={getEmploymentType() === 'private' || isStateEmployee}
                                                            >
                                                                <option value="">Seleziona</option>
                                                                <option value="on">Sì</option>
                                                                <option value="off">No</option>
                                                            </Form.Control>
                                                        </div>
                                                    )}

                                                    {/* Part Time Percentage - Only for private employees with part time */}
                                                    {(getEmploymentType() === 'private' || isStateEmployee) && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='part_time_percentage' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Percentuale Part Time % <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type='number' 
                                                                step="0.1"
                                                                onWheel={(e) => e.target.blur()}
                                                                className="form-control" 
                                                                name='part_time_percentage' 
                                                                placeholder=''
                                                                value={inputs["part_time_percentage"]}
                                                                onChange={handleChange}
                                                                required={(getEmploymentType() === 'private' || isStateEmployee) && inputs.is_part_time === 'on'}
                                                                disabled={inputs.is_part_time !== 'on'}
                                                            />
                                                        </div>
                                                    )}


                                                    {/* Stipendio Lordo - Only for private employees */}
                                                    {getEmploymentType() === 'private' && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='retribuzione' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Stipendio Lordo <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type='number' 
                                                                step="1"
                                                                onWheel={(e) => e.target.blur()}
                                                                className="form-control" 
                                                                name='retribuzione' 
                                                                placeholder=''
                                                                value={inputs["retribuzione"]}
                                                                onChange={handleChange}
                                                                required={getEmploymentType() === 'private'}
                                                            />
                                                        </div>
                                                    )}

                                                    {/* Mensilità - Only for private employees */}
                                                    {getEmploymentType() === 'private' && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='mensilita' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Mensilità <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name='mensilita'
                                                                value={inputs["mensilita"]}
                                                                onChange={handleChange}
                                                                required={getEmploymentType() === 'private'}
                                                            >
                                                                <option value="13">13</option>
                                                                <option value="14">14</option>
                                                            </Form.Control>
                                                        </div>
                                                    )}

                                                    {/* TFR - Only for private employees */}
                                                    {getEmploymentType() === 'private' && !isPublicEmployee && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='tfr' className="form-label font-weight-bold text-muted text-uppercase">
                                                                TFR (per dip. privati e parapubblici)
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type='number' 
                                                                step="0.1"
                                                                onWheel={(e) => e.target.blur()}
                                                                className="form-control" 
                                                                name='tfr' 
                                                                placeholder=''
                                                                value={inputs["tfr"]}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Text className="text-muted">
                                                                Se vuoto, il sistema simula l'importo del TFR
                                                            </Form.Text>
                                                        </div>
                                                    )}

                                                    {/* TFR Data Riferimento - Only for private employees */}
                                                    {getEmploymentType() === 'private' && !isPublicEmployee && (
                                                        <div className="col-md-6 mb-3">
                                                            <Form.Label htmlFor='tfr_data_rif' className="form-label font-weight-bold text-muted text-uppercase">
                                                                TFR Data Riferimento
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type='date' 
                                                                className="form-control" 
                                                                name='tfr_data_rif' 
                                                                value={inputs["tfr_data_rif"]}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    )}

                                                    {/* Tempo Indeterminato - Only for private employees - Full width */}
                                                    {(getEmploymentType() === 'private' || getEmploymentType() === 'state') && (
                                                        <div className="col-12 mb-3">
                                                            <Form.Label htmlFor='is_tempo_indeterminato' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Tempo Indeterminato <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name='is_tempo_indeterminato'
                                                                value={inputs["is_tempo_indeterminato"]}
                                                                onChange={handleChange}
                                                                required={getEmploymentType() === 'private' || getEmploymentType() === 'state'}
                                                            >
                                                                <option value="">Seleziona</option>
                                                                <option value="on">Sì</option>
                                                                <option value="off">No</option>
                                                            </Form.Control>
                                                        </div>
                                                    )}

                                                    {/* Malattia - Only for private employees - Full width */}
                                                    {getEmploymentType() === 'private' && (
                                                        <div className="col-12 mb-3">
                                                            <Form.Label htmlFor='malattia' className="form-label font-weight-bold text-muted text-uppercase">
                                                                Malattia oltre 10 Giorni in Busta Paga <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name='malattia'
                                                                value={inputs["malattia"]}
                                                                onChange={handleChange}
                                                                required={getEmploymentType() === 'private'}
                                                            >
                                                                <option value="">Seleziona</option>
                                                                <option value="on">Sì</option>
                                                                <option value="off">No</option>
                                                            </Form.Control>
                                                        </div>
                                                    )}

                                                    {/* CIGS oltre 40 ore - Only for private employees - Full width */}
                                                    {getEmploymentType() === 'private' && (
                                                        <div className="col-12 mb-3">
                                                            <Form.Label htmlFor='cig_oltre_40_ore' className="form-label font-weight-bold text-muted text-uppercase">
                                                                CIGS oltre 40 giorni in Busta Paga <span className="text-danger">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                as="select"
                                                                name='cig_oltre_40_ore'
                                                                value={inputs["cig_oltre_40_ore"]}
                                                                onChange={handleChange}
                                                                required={getEmploymentType() === 'private'}
                                                            >
                                                                <option value="">Seleziona</option>
                                                                <option value="on">Sì</option>
                                                                <option value="off">No</option>
                                                            </Form.Control>
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Prestiti Section */}
                                                <div className="row mt-4">
                                                    <div className="col-12">
                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                            <h5 className="font-weight-bold">Altri Impegni Gia In Corso</h5>
                                                            <Button 
                                                                type="button" 
                                                                variant="outline-primary" 
                                                                size="sm"
                                                                onClick={addPrestito}
                                                            >
                                                                + Aggiungi Impegni
                                                            </Button>
                                                        </div>
                                                        
                                                        {prestiti.length === 0 ? (
                                                            <Alert variant="info">
                                                                Nessun prestito aggiunto. Clicca su "Aggiungi Prestito" per aggiungere prestiti esistenti.
                                                            </Alert>
                                                        ) : (
                                                            prestiti.map((prestito, index) => (
                                                                <Card key={index} className="mb-3">
                                                                    <Card.Body>
                                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                                            <h6>Impegni {index + 1}</h6>
                                                                            <Button 
                                                                                type="button" 
                                                                                variant="outline-danger" 
                                                                                size="sm"
                                                                                onClick={() => removePrestito(index)}
                                                                            >
                                                                                Rimuovi
                                                                            </Button>
                                                                        </div>
                                                                        
                                                                        <div className="row">
                                                                            {/* Da Estinguere */}
                                                                            <div className="col-md-6 mb-3">
                                                                                <Form.Label className="form-label font-weight-bold text-muted text-uppercase">
                                                                                    Da Estinguere <span className="text-danger">*</span>
                                                                                </Form.Label>
                                                                                <Form.Control
                                                                                    as="select"
                                                                                    value={prestito.da_estinguere}
                                                                                    onChange={(e) => handlePrestitoChange(index, 'da_estinguere', e.target.value)}
                                                                                    required
                                                                                >
                                                                                    <option value="">Seleziona</option>
                                                                                    <option value="on">Sì</option>
                                                                                    <option value="off">No</option>
                                                                                </Form.Control>
                                                                            </div>

                                                                            {/* Tipo */}
                                                                            <div className="col-md-6 mb-3">
                                                                                <Form.Label className="form-label font-weight-bold text-muted text-uppercase">
                                                                                    Tipo <span className="text-danger">*</span>
                                                                                </Form.Label>
                                                                                <Form.Control
                                                                                    as="select"
                                                                                    value={prestito.tipo}
                                                                                    onChange={(e) => handlePrestitoChange(index, 'tipo', e.target.value)}
                                                                                    required
                                                                                >
                                                                                    <option value="">Seleziona</option>
                                                                                    <option value="Cessione del Quinto">Cessione del Quinto</option>
                                                                                    <option value="Delega">Delega</option>
                                                                                    <option value="Pignoramento">Pignoramento</option>
                                                                                    <option value="Altri Prestiti">Altri Prestiti</option>
                                                                                </Form.Control>
                                                                            </div>
                                                                            
                                                                            {/* Rata - Only for Cessione del Quinto or Delega */}
                                                                            {(prestito.tipo === 'Cessione del Quinto' || prestito.tipo === 'Delega') && (
                                                                                <div className="col-md-4 mb-3">
                                                                                    <Form.Label className="form-label font-weight-bold text-muted text-uppercase">
                                                                                        Rata <span className="text-danger">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control 
                                                                                        type='number' 
                                                                                        step="1"
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control"
                                                                                        value={prestito.rata}
                                                                                        onChange={(e) => handlePrestitoChange(index, 'rata', e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            
                                                                            {/* Durata - Only for Cessione del Quinto or Delega */}
                                                                            {(prestito.tipo === 'Cessione del Quinto' || prestito.tipo === 'Delega') && (
                                                                                <div className="col-md-4 mb-3">
                                                                                    <Form.Label className="form-label font-weight-bold text-muted text-uppercase">
                                                                                        Durata <span className="text-danger">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control
                                                                                        as="select"
                                                                                        value={prestito.durata}
                                                                                        onChange={(e) => handlePrestitoChange(index, 'durata', e.target.value)}
                                                                                        required
                                                                                    >
                                                                                        <option value="">Seleziona</option>
                                                                                        <option value="24">24</option>
                                                                                        <option value="36">36</option>
                                                                                        <option value="48">48</option>
                                                                                        <option value="60">60</option>
                                                                                        <option value="72">72</option>
                                                                                        <option value="84">84</option>
                                                                                        <option value="96">96</option>
                                                                                        <option value="108">108</option>
                                                                                        <option value="120">120</option>
                                                                                    </Form.Control>
                                                                                </div>
                                                                            )}
                                                                            
                                                                            {/* Decorrenza - Only for Cessione del Quinto or Delega */}
                                                                            {(prestito.tipo === 'Cessione del Quinto' || prestito.tipo === 'Delega') && (
                                                                                <div className="col-md-4 mb-3">
                                                                                    <Form.Label className="form-label font-weight-bold text-muted text-uppercase">
                                                                                        Decorrenza <span className="text-danger">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control 
                                                                                        type='date' 
                                                                                        className="form-control"
                                                                                        value={prestito.decorrenza}
                                                                                        onChange={(e) => handlePrestitoChange(index, 'decorrenza', e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </div>
                                                                            )}

                                                                            {/* Residuo - Only for Altri Prestiti */}
                                                                            {prestito.tipo === 'Altri Prestiti' && (
                                                                                <div className="col-md-12 mb-3">
                                                                                    <Form.Label className="form-label font-weight-bold text-muted text-uppercase">
                                                                                        Residuo <span className="text-danger">*</span>
                                                                                    </Form.Label>
                                                                                    <Form.Control 
                                                                                        type='number' 
                                                                                        step="0.1"
                                                                                        onWheel={(e) => e.target.blur()}
                                                                                        className="form-control"
                                                                                        value={prestito.residuo}
                                                                                        onChange={(e) => handlePrestitoChange(index, 'residuo', e.target.value)}
                                                                                        required
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </Card.Body>
                                                                </Card>
                                                            ))
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="mt-4">
                                                    {loading ? 
                                                        <Button type="button" disabled>
                                                            <ReactLoading
                                                                className="mx-auto"
                                                                type={"spin"}
                                                                color={"#fefefe"}
                                                                height={24}
                                                                width={24}
                                                            />
                                                        </Button> 
                                                        : 
                                                        <Button type="submit">Elabora</Button>
                                                    }
                                                </div>
                                            </>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    )}

                    {/* Result Modal */}
                    <Modal show={showResultModal} onHide={() => setShowResultModal(false)} size="xl">
                        <Modal.Header closeButton>
                            <Modal.Title>Risultati Elaborazione</Modal.Title>
                            <div className="ms-auto d-flex gap-2">
                                <Button 
                                    variant="outline-secondary"
                                    onClick={() => setShowRejections(!showRejections)}
                                    className="mx-1"
                                >
                                    {showRejections ? 'Mostra Possibilità' : 'Mostra Scarti'}
                                </Button>
                                {savedCriteriId && contactId && selectedProductId && (
                                    <Button 
                                        className="mx-1"
                                        variant="success"
                                        onClick={() => {
                                            const params = new URLSearchParams({
                                                contact_id: contactId,
                                                product_id: selectedProductId,
                                                opportunity_id: opportunityId || ''
                                            });
                                            history.push(`/preventivi?${params.toString()}`);
                                        }}
                                    >
                                        Vai a Preventivi
                                    </Button>
                                )}
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            {showRejections ? (
                                <div className="rejections-list">
                                    <h5>Motivi di Scarto</h5>
                                    {successResult?.rejections && successResult.rejections.length > 0 ? (
                                        <ul className="list-group">
                                            {successResult.rejections.map((rejection, index) => (
                                                <li key={index} className="list-group-item list-group-item-danger">
                                                    {rejection}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <Alert variant="info">Nessuno scarto rilevato.</Alert>
                                    )}
                                </div>
                            ) : (
                                <div className="possibilities-table">
                                    <h5>Possibilità</h5>
                                    {successResult?.possibilities && successResult.possibilities.length > 0 ? (
                                        <Table striped bordered hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>Banca</th>
                                                    <th>Assicurazione</th>
                                                    <th>Durata</th>
                                                    <th>Rata Massima</th>
                                                    <th>Montante</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {successResult.possibilities.map((possibility, index) => (
                                                    <tr key={index}>
                                                        <td className='py-1' >{possibility[0]}</td>
                                                        <td className='py-1' >{possibility[1]}</td>
                                                        <td className='py-1' >{possibility[2]}</td>
                                                        <td className='py-1' >{possibility[3]}</td>
                                                        <td className='py-1' >{possibility[4]}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    ) : (
                                        <Alert variant="warning">Nessuna possibilità trovata.</Alert>
                                    )}
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowResultModal(false)}>
                                Chiudi
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Row>
            </Container>
        </>
    );
};

export default Criteri;